import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Container,
  OptionContainer,
  OptionsContainer,
  QuestionContainer,
} from "./styles";

const LessonTeste = (props) => {
  const [id, setId] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [questoes, setQuestoes] = useState([]);

  useEffect(() => {
    const id = props.teste.id;
    const titulo = props.teste.titulo;
    const questoes = JSON.parse(props.teste.json)?.questoes;

    setId(id);
    setTitulo(titulo);
    setQuestoes(questoes);
  }, [props.teste]);

  const handleTitulo = useCallback(
    (e) => {
      const { value } = e.target;

      props.handleTeste({
        id,
        titulo: value,
      });
    },
    [id]
  );

  const handlePergunta = useCallback(
    (e, index) => {
      const { value } = e.target;
      const newQuestoes = [...questoes];

      newQuestoes[index].pergunta = value;

      props.handleTeste({
        id,
        json: JSON.stringify({ titulo, questoes: newQuestoes }),
      });
    },
    [questoes, titulo, id]
  );

  const handleOpcaoIsAnswer = useCallback(
    (e, indexQuestao, indexOpcao) => {
      const { value } = e.target;
      const newQuestoes = [...questoes];

      const newOpcoes = [...newQuestoes[indexQuestao].opcoes];

      newOpcoes[indexOpcao].isAnswer = !newOpcoes[indexOpcao].isAnswer;

      newQuestoes[indexQuestao].opcoes = newOpcoes;

      props.handleTeste({
        id,
        json: JSON.stringify({ titulo, questoes: newQuestoes }),
      });
    },
    [questoes, titulo, id]
  );

  const handleOpcaoText = useCallback(
    (e, indexQuestao, indexOpcao) => {
      const { value } = e.target;
      const newQuestoes = [...questoes];

      const newOpcoes = [...newQuestoes[indexQuestao].opcoes];

      newOpcoes[indexOpcao].texto = value;

      newQuestoes[indexQuestao].opcoes = newOpcoes;

      props.handleTeste({
        id,
        json: JSON.stringify({ titulo, questoes: newQuestoes }),
      });
    },
    [questoes, titulo, id]
  );

  return (
    <Container>
      <h1>TESTE:</h1>

      <input value={titulo} title="Título" onChange={handleTitulo} />
      {questoes.map((questao, indexQuestao) => (
        <QuestionContainer>
          <input
            value={questao.pergunta}
            title={`Pergunta ${indexQuestao + 1}`}
            onChange={(e) => handlePergunta(e, indexQuestao)}
          />
          <OptionsContainer>
            {questao.opcoes.map((opcao, indexOpcao) => (
              <OptionContainer title={`Opção ${indexOpcao + 1}`}>
                <input
                  type="radio"
                  checked={!!opcao.isAnswer}
                  onClick={(e) =>
                    handleOpcaoIsAnswer(e, indexQuestao, indexOpcao)
                  }
                />
                <textarea
                  value={opcao.texto}
                  onChange={(e) => handleOpcaoText(e, indexQuestao, indexOpcao)}
                />
              </OptionContainer>
            ))}
          </OptionsContainer>
        </QuestionContainer>
      ))}
    </Container>
  );
};

export default LessonTeste;
